import createReactComponent from '../createReactComponent';
export default createReactComponent('restore', 'IconRestore', [
  ['path', { d: 'M3.06 13a9 9 0 1 0 .49 -4.087', key: 'svg-0' }],
  ['path', { d: 'M3 4.001v5h5', key: 'svg-1' }],
  ['path', { d: 'M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0', key: 'svg-2' }],
]);
